import { StyledHeader } from "./styles";

const HeaderMobile = () => {
  return (
    <StyledHeader>
      <div className="container">
        <nav>
          <a href="#home">Home</a>
          <a href="#projects">Projects</a>
          <a href="#aboutme">About me</a>
          <a href="#contact">Contact</a>
        </nav>
      </div>
    </StyledHeader>
  );
};

export default HeaderMobile;
